import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';

const TranslatedLabel = ({ id }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  return <label className="tempedge-control-label-semibold">{tempedgeTranslator(`${id}`)}</label>;
};

export default TranslatedLabel;
